<template>
  <div class="main-app" :class="{ 'main-app--fullscreen': isFullScreen}">
    <div class="spinner permanent" id="spinner" v-show="isLoading"></div>
<!--    <div id="nav">
      <router-link to="/venues">Venues</router-link> |
&lt;!&ndash;      <router-link to="/about">About</router-link> |&ndash;&gt;
&lt;!&ndash;      <router-link to="/packages">Packages</router-link> |&ndash;&gt;
&lt;!&ndash;      <router-link to="/enhancements">Enhancements</router-link>&ndash;&gt;
    </div>-->
    <router-view/>


  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import ImageSlider from '@/components/image-slider/ImageSlider'
  import SliderControls from '@/components/image-slider/SliderControls'
  import './styles/main.scss';


  export default {
    name    : 'app',
    components: {
      'image-slider': ImageSlider,
      'slider-controls': SliderControls
    },
    data () {
      return {
        // wpUrl : 'http://staging.petcoparkevents.com/swp/wp-json/wp/v2/',
        wpUrl : 'https://petcoparkevents.com/wp-json/wp/v2/',
        debug : false,
        errors: []
      }
    },
    computed: {
      ...mapState([
        'isFullScreen',
        'isLoading',
        'images'
      ]),
    },
    methods: {
      ...mapMutations([
        'setRootEl'
      ]),
      updateFullScreen(){
        this.$store.commit('toggleFullScreen');
      },

    },
    mounted(){
      // this.setRootEl(this.$el);
    },
    watch: {}

  }
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  position: absolute;
  /*width: 100%;*/
  /*top: 0;*/
  left: 50%;
  z-index: 100;
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.main-app {
  min-height: calc(100vh - 96px - 300px);
  max-width: 1600px;
  margin: 0 auto;
  //height: calc(100vh - 60px);
  /*min-height: 100%;*/
  position: relative;
  width: 100%;
  &--fullscreen {
    height: 100vh;
    .panel {
      height: 100vh;

      &:before {
        height: 100vh;
      }
    }
  }
}
.spinner {
  position: absolute;
  left: 48%;
  top: 50%;
  z-index: 1;
}
.pre {
  text-align: left;
}
.reset {
  position: absolute;
  z-index: 999;
}
</style>
